import {
  createFrontendModule,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { adrTranslationRef } from '@backstage-community/plugin-adr/alpha';

/**
 * Override the ADR plugin's `contentHeaderTitle` translation from
 * "Architecture Decision Records" → "Any Decision Records" to match
 * our broader usage of ADRs (not strictly architecture-scoped).
 */
const adrTranslation = TranslationBlueprint.make({
  name: 'adr',
  params: {
    resource: createTranslationMessages({
      ref: adrTranslationRef,
      messages: {
        contentHeaderTitle: 'Any Decision Records',
      },
    }),
  },
});

export const adrTranslationModule = createFrontendModule({
  pluginId: 'app',
  extensions: [adrTranslation],
});
